import { render, staticRenderFns } from "./FooterPartial.htm?vue&type=template&id=4be5dc8b&scoped=true&external"
import script from "./FooterPartial.js?vue&type=script&lang=js&external"
export * from "./FooterPartial.js?vue&type=script&lang=js&external"
import style0 from "./FooterPartial.scss?vue&type=style&index=0&id=4be5dc8b&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4be5dc8b",
  null
  
)

export default component.exports